<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null">
        <span class="text">{{ msgAlerta }}</span>
    </div>


    <div v-if="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Código</th>
                <th>Nome/Descrição</th>
                <th>Situação</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cddepartamento) }}</td>
                    <td>{{ obj.nmdepartamento }}</td>
                    <td class="col-width-char30 center">{{ obj.nmativo }}</td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <div class="form-edit-page">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cddepartamento) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Descrição</label>
                    <input type="text" v-model="objEdicao.nmdepartamento" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Ativo</label>
                    <select v-model="objEdicao.ativo">
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                    </select>
                </div>
            </div>
            

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Informações do Departamento</label>
                    <textarea v-model="objEdicao.detalhamento" maxlength="3000" rows="5" style="resize: none;"/>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Permissão de Acesso por Perfil de Usuário:</label>

                    <div class="perfil-card-grid">
                        <div
                            v-for="perfil in lsPerfil"
                            :key="perfil.id"
                            class="perfil-card"
                            :class="{ ativo: perfil.ckvinculado === 'S' }"
                            @click="alternarPerfil(perfil)"
                        >
                            <div class="perfil-card-info">
                                <strong>{{ perfil.nmperfil }}</strong>
                                <span>{{ perfil.ckvinculado === 'S' ? 'Permitido' : 'Não Permitido' }}</span>
                            </div>

                            <div class="perfil-switch" :class="{ ativo: perfil.ckvinculado === 'S' }">
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row-end">
                <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
                <button type="button" class="btn-cancel" @click="modoEdicao=false">Cancelar</button>
            </div>
        </div>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport.js';
import { criarManifDepartamento } from '@/models/ManifDepartamento';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';

const emit = defineEmits(['close']);

const msgAlerta = ref(null);
const nmPesquisa = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const objEdicao = ref(criarManifDepartamento());
const lsPerfil = ref([]);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function alternarPerfil(obj) {
    obj.ckvinculado = obj.ckvinculado === 'S' ? 'N' : 'S';
}


function closeForm() {emit('close');}


function editarCadastro(obj) {
    setEdicao(obj.id);
}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/manif_departamento', {
            idmunicipio: globalStore.idmunicipio,
            nmpesquisar: nmPesquisa.value,
        });
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value = false;}
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;
        const response  = await Api.genericPut('/cad/manif_departamento', objEdicao.value);
        if (response.bolok === 1){
            const idDep = response.id;

            // GRAVAR ALTERAÇÕES DE ACESSO
            const perfisAlterados = lsPerfil.value.filter(obj =>
                obj.ckvinculado !== obj.ckvinculado_original
            );

            for (const obj of perfisAlterados) {
                await Api.genericPost('/cad/exec_requisicao', {
                    nmrequisicao: "manifDepartamentoPerfil",
                    intparam1: idDep,
                    intparam2: obj.id,
                    ativo: obj.ckvinculado,
                    idlogin: globalStore.idlogin
                });
            }

            await lerDados();
            modoEdicao.value = false;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function setEdicao(idEdicao) {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (idEdicao > 0) {
            const req = await Api.getCadastroById('manif_departamento', idEdicao);
            Object.assign(objEdicao.value, req[0]);
        }else{
            objEdicao.value = criarManifDepartamento();
            objEdicao.value.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.value.idlogin = globalStore.idlogin;

        // LISTAR PERFIL COM OPÇÃO DE VINCULADO AO DEPERTAMENTO
        const rPerfil = await Api.genericPost('/listas/perfil/manif_departamento', {
            idmunicipio: globalStore.idmunicipio,
            idreferencia: idEdicao,
        });

        lsPerfil.value = rPerfil.map(perfil => ({
            ...perfil,
            ckvinculado_original: perfil.ckvinculado
        }));

        modoEdicao.value = true;
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value=false;}
}


function novoCadastro() {
    setEdicao(0);
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


function validarDados(){
    let x = '';
    let r = Validar.texto(objEdicao.value.nmdepartamento, '\n-Informe nome do departamento');
    if (!r.ok) x += r.msg;
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}


onMounted(lerDados);
</script>


<style scoped>
.perfil-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
    margin-top: 6px;
}

.perfil-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    background: #ffffff;

    cursor: pointer;
    transition: 0.15s ease;
}

.perfil-card:hover {
    border-color: #9ca3af;
    background: #f9fafb;
}

.perfil-card.ativo {
    border-color: #2563eb;
    background: #eff6ff;
}

.perfil-card-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.perfil-card-info strong {
    font-size: 14px;
    color: #1f2937;
}

.perfil-card-info span {
    font-size: 12px;
    color: #6b7280;
}

.perfil-switch {
    width: 42px;
    height: 22px;
    border-radius: 999px;
    background: #d1d5db;
    padding: 3px;
    flex-shrink: 0;
    transition: 0.15s ease;
}

.perfil-switch span {
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ffffff;
    transition: 0.15s ease;
}

.perfil-switch.ativo {
    background: #2563eb;
}

.perfil-switch.ativo span {
    transform: translateX(20px);
}
</style>